export const BASE_URL = "https://quanlyhosobiomass.com/biomass/";